import { render, staticRenderFns } from "./TopFive.vue?vue&type=template&id=4875e163&scoped=true&"
import script from "./TopFive.vue?vue&type=script&lang=js&"
export * from "./TopFive.vue?vue&type=script&lang=js&"
import style0 from "./TopFive.vue?vue&type=style&index=0&id=4875e163&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4875e163",
  null
  
)

export default component.exports